@if (loading()) {
  <div class="flex flex-column gap-4 p-6 align-items-center">
    <p-progressSpinner ariaLabel="loading" class="customProgressSpinner" />

    <span class="loadingText p-3">
      {{ "energy_tool.energy_export.loading" | translate }}
    </span>
  </div>
} @else {
  <div class="modalForm">
    <div class="flex flex-column gap-2 mb-3">
      <span> {{ "energy_tool.energy_export.dialog_date" | translate }} </span>
      <p-datepicker
        inputStyleClass="w-full"
        [readonlyInput]="true"
        iconDisplay="input"
        dateFormat="mm.yy"
        appendTo="body"
        [(ngModel)]="exportDate"
        [maxDate]="maxDate"
        view="month"
      />
    </div>
    <div class="flex flex-column gap-2 mb-3">
      <span>{{ "energy_tool.energy_export.dialog_language" | translate }}</span>

      <p-select [options]="languages" [(ngModel)]="selectedLanguage" class="w-full"
        ><ng-template let-lang #selectedItem>
          {{ lang.label | translate }}
        </ng-template>
        <ng-template let-lang #item>
          {{ lang.label | translate }}
        </ng-template>
      </p-select>
    </div>

    <div class="flex justify-content-end gap-2 dialogBtnGroup">
      <app-button buttonText="common.cancel" (click)="closeDialog()"></app-button>
      <app-button
        color="primary"
        buttonText="energy_tool.energy_export.dialog_save"
        (click)="startExport()"
      ></app-button>
    </div>
  </div>
}
